/***
 * 创建人：段锐
 * 时间：2019-06-10
 * 描述：对数字进行验证
 * 更新记录: 
 */
import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[validateNumber][ngModel]',
  providers:[{provide:NG_VALIDATORS,useExisting:forwardRef(()=>ValidatorNumberDirective),multi:true}]
})
export class ValidatorNumberDirective {

  ///这是判断需要什么类型的校验
  @Input('validateNumber')
  type:any;
  
  constructor() { }

  validate(control:AbstractControl):{[property:string]:string}{
    let reg1 = /^[1-9]\d*$/;//正整数
    let reg2 =/^[0-9]\d*$/;//非负整数
    let reg3 =/^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])$/;//大于0的数字
    let reg4 = /^[0-9]{1,14}(\.{0,1}[0-9]{1,2})?$/;//小数只能填写两位以下的小数
    let reg5 = /^1[1-9][0-9]{0,3}$/;//最大为4位数的正整数 1-9999
    let reg6 = /^[1-9][0-9]{0,4}$/;//最大为5位数的正整数 1-99999
    let reg7 = /^[1-9][0-9]{0,5}$/;//最大为6位数的正整数 1-999999
    let reg8 = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;//0-90
    let reg9 = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;//0-180
    let reg10 = /^(?:0|[1-9][0-9]?|100)$/;//[0,100]的正整数
    let reg11 = /^(?:100(?:\.0+)?|0(?:\.\d+)?|[1-9]\d?(?:\.\d+)?)$/;//[0,100]支持小数
    
    let number = control.value;//取得输入框的值
    if(number===null || number==="" || number === undefined){ //为空时不验证
      return null
    }
      switch(this.type){
        case "PositiveInt"://非负整数
        return reg2.test(number)?null:{validateNumber:"false"}
        case "PositiveIntLimit4"://最大为4位数的正整数
        return reg5.test(number)?null:{validateNumber:"false"}
        case "PositiveIntLimit5"://最大为5位数的正整数
        return reg6.test(number)?null:{validateNumber:"false"}
        case "PositiveIntLimit6"://最大为6位数的正整数
        return reg7.test(number)?null:{validateNumber:"false"}
        case "Latitude"://0-90,小数点后六位
        return reg8.test(number)?null:{validateNumber:"false"}
        case "Longitude"://0-180,小数点后六位
        return reg9.test(number)?null:{validateNumber:"false"}
        case "NonNegativeInt"://正整数
        return reg1.test(number)?null:{validateNumber:"false"}
        case "Decimal"://小数只能填写两位以下的小数
        return reg4.test(number)?null:{validateNumber:"false"}
        case "PositiveIntLimit7"://[0,100]的正整数
        return reg10.test(number)?null:{validateNumber:"false"}
        case "PercentDecimal"://[0,100]支持小数
        return reg11.test(number)?null:{validateNumber:"false"}
        default://大于0的数字
        return reg3.test(number)?null:{validateNumber:"false"}
      }
  }
}
